'use client'

import { styled } from '@mui/material'

export const StyledFooter = styled('footer')(({ theme }) => ({
}))
